<template>
  <div
    v-if="autolawyerOptions.length"
    class="addon-card addon-card--autolawyer"
  >
    <h4 class="addon-card__heading">
      Автоюрист
      <span class="addon-card__icon"><AutolawyerIcon /></span>
    </h4>
    <p class="addon-card__description">
      Рекомендуємо скористатися послугами автоюриста, щоб мати захист у разі ДТП або спірних ситуацій на дорозі.
    </p>
    <Select
      class="addon-card__select"
      :value="autolawyer"
      :options="autolawyerOptions"
      :select-first-by-default="false"
      :clearable="autolawyer !== null"
      :is-disabled="isDisabled"
      placeholder="Автоюрист"
      @change="onAutolawyerOptionChange"
    />
  </div>
</template>

<script>
import { Select } from '@/shared/ui/form';
import { AutolawyerIcon } from '@/shared/ui/icons';

export default {
  props: {
    autolawyerOptions: {
      type: Array,
      default: () => [],
    },
    autolawyer: {
      type: String,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  components: { AutolawyerIcon, Select },
  methods: {
    onAutolawyerOptionChange(option) {
      this.$emit('autolawyer-option-changed', option);
    },
  },
};
</script>

<style scoped lang="scss">
.addon-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  border-radius: 8px;
  padding: 16px;

  &__heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 8px;
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background-color: #ffffff;
    border-radius: 50%;

    svg {
      width: 24px;
      height: 24px;
    }
  }

  &__description {
    font-size: 14px;
    font-weight: 400;
    margin: 0 50px 16px 0;
    text-align: left;
    word-break: break-word;
    hyphens: auto;

    @media (max-width: 500px) {
      margin: 0 0 16px;
    }
  }

  &__select {
    width: 100%;
  }

  &--autolawyer {
    background-color: #ffe7f9;

    .addon-card__heading {
      color: #c9408c;
    }

    .addon-card__description {
      color: #e75eaa;
    }
  }
}
</style>
